import React from 'react';

export default class PlaceholderDateInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            focused: false
        };
    }

    onBlur() {
        if(this.state.focused && !this.props.value) this.setState({focused: false})
    }

    onFocus() {
        this.setState({focused: true}, () => {
                this.textInput.focus();
        });

    }

    render() {
        return (
            <div>
                {!this.state.focused && <input type="text" placeholder={this.props.placeholder}  {...this.props} onFocus={this.onFocus.bind(this)} />}
                {this.state.focused && 
                    <input type="date" max="9999-12-31" name={this.props.name} value={this.props.value} 
                        onChange={this.props.onChange} {...this.props} 
                        onBlur={this.onBlur.bind(this)} 
                        ref={(input) => { this.textInput = input; }}/>}
            </div>
        );
    }

}
//props: name, value, placeholder, onChange


// WEBPACK FOOTER //
// ./src/components/commonComponents/util/PlaceholderDateInput.jsx